import { render, staticRenderFns } from "./incomeAddGoodsDialog.vue?vue&type=template&id=12439896&"
import script from "./incomeAddGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./incomeAddGoodsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports